import {
  boolean,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import { createSorterSchema, TRUCKS_SORT_KEYS } from '@/features/shared/models'

export const TrucksSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(TRUCKS_SORT_KEYS),
  dcId: optional(number()),
  name: optional(string()), // 車両名
  code: optional(string()), // 車両番号
  partnerId: optional(number()), // パートナー
  subPartnerId: optional(number()), //運送会社
  truckClassId: optional(number()), // 車格
  truckTypeId: optional(number()), // 車両属性
  truckImportJobId: optional(number()), // 取込ジョブID
  enable: optional(boolean()) // 有効・無効
})

export type TrucksSearch = InferOutput<typeof TrucksSearchSchema>
